import styled from 'styled-components';

export const ArticleText = styled.div`
  margin-top: 2em;

  p {
    font-size: 0.9em;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    display: inline-block;
    margin-top: 1em;

    &:first-child {
      margin-top: 0;
    }
  }

  .inline-image {
    width: 100%;
    margin-bottom: 2em;
    object-fit: contain;

    @media all and (min-width: 960px) {
      margin-top: 0;
      margin-left: 2em;
      max-width: 45%;
      float: right;
    }
  }
`;
